import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;
`;

export const ActionButtons = styled.div`
    flex-direction: row;
`;

export const ExcelButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-top: -8px;
    margin-bottom: 16px;
`;
